import { useTranslation } from 'react-i18next';

import { ApiStatuses, NotificationPosition } from 'coreOld/enums';
import { useNotification } from 'coreOld/hooks/useNotification';
import { useRequestActions } from 'support/hooks';
import { mapUpsertRequestsForm } from 'support/mappers';
import { IRequest, IUpdateRequestForm } from 'support/types';
import { validateRequestedDate } from 'support/utils';

import UpdateRequestFormView from './UpdateRequestFormView';
import { Dispatch, SetStateAction, useEffect } from 'react';

interface IProps {
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  selectedItems: IRequest[];
  setCloseSelection: Dispatch<SetStateAction<boolean>>;
}

const UpdateRequestForm = ({ isOpen, setIsOpen, selectedItems, setCloseSelection }: IProps) => {
  const { t } = useTranslation();
  const { clearModalNotification, showNotification } = useNotification();
  const { upsertRequests } = useRequestActions({
    multiple: selectedItems?.length > 1,
  });

  const onSubmit = () => async (data: IUpdateRequestForm) => {
    const { success } = await upsertRequests(mapUpsertRequestsForm(selectedItems, data));

    if (!success) {
      return;
    }

    setCloseSelection(true);
    setIsOpen(false);
  };

  const onRequiredDateChange = (date: string) => {
    const showInfo = !validateRequestedDate(date);

    if (showInfo) {
      showNotification({
        message: t('errorRequestedDate2Days'),
        type: ApiStatuses.ERROR,
        position: NotificationPosition.MODAL,
      });
    }

    if (!showInfo) {
      clearModalNotification();
    }
  };

  return (
    <UpdateRequestFormView
      isOpen={isOpen}
      onClose={() => setIsOpen(false)}
      onSubmit={onSubmit}
      onRequiredDateChange={onRequiredDateChange}
      selectedItemsCount={selectedItems?.length}
    />
  );
};

export default UpdateRequestForm;
